import { types } from './reducer';

const useActions = (state, dispatch) => ({
  errorAction: (data) => dispatch({ type: types.ERROR, payload: data }),
});

export default useActions;
